import { useContext } from "react";
import {
  MaximumMortgageWizardContext,
  type MaximumMortgageWizardContextType,
} from "../contexts/MaximumMortgageWizardContext";

export const useMaximumMortgageWizard =
  (): MaximumMortgageWizardContextType => {
    const context = useContext(MaximumMortgageWizardContext);
    if (!context) {
      throw new Error(
        "useMaximumMortgageWizard must be used within a MaximumMortgageWizardProvider",
      );
    }
    return context;
  };
